import React, { Component } from 'react';
import { getArticles } from '../../data/ArticleSelector';
import { getBookLists } from '../../data/BookListsSelector';
import { BookListsCarousel, mapOtsAvailability } from '@novelist/novum-novella-ui';
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import * as authorUtil from '../../lib/AuthorUtility';
import CatalogLink from '../../lib/CatalogLink';

import { getAvailabilityConfiguration } from '../../data/DataStore';
import { getOtsAvailabilityForResults } from '../../data/OtsRequests';

class BookListsCarouselContainer extends Component {
	constructor() {
		super();
		const article = getArticles("Grab and Go Book Lists")
			.concat(getArticles("Appeal browse"))
			.concat(getArticles("Genre browse"))
			.concat(getArticles("Recommended Reads"))
			.concat(getArticles("Curated List"));
		const bookLists = article.map(art => {
			return {
				key: art.ui,
				label: art.title
			}
		});
		
		this.availabilityConfiguration = getAvailabilityConfiguration();
		this.state = {
			dataToSet: [],
			currentUi: undefined,
			bookLists: bookLists
		};
		this.postAction = this.postAction.bind(this);
		this.booksCallFunctionCallBack = this.booksCallFunctionCallBack.bind(this);
	}
  
	postAction(data){
		let titles = ( !data || !data.ListEntryContent) ? [] : this.sortData(data).map((entity) => {
			return {
				ui: entity.NoveListRecord.UI,
				mainTitle: entity.NoveListRecord.NormalizedTitle,
				bookjacketUrl: entity.NoveListRecord.PrimaryBookJacket,
				catalogLinkUrl: entity.IsHeldLocally === false ? null : new CatalogLink(entity.TitleCatalogFullLink.url, entity.TitleCatalogFullLink.target),
				description: entity.NoveListRecord.Description,
				isHeld: entity.IsHeldLocally,
				author: authorUtil.formatAuthorName(entity.NoveListRecord.Author)
			};
		});

		if(titles.length > 0){
			this.setState({ dataToSet: titles });
		}		
		if (titles.length > 0 && data.OtsResultRelativeUrl)
		{
			Promise.resolve(getOtsAvailabilityForResults(data))
			.then((value) =>{
				titles.map(item =>{
					let otsDataForTitle = value && value.find(titleOts => {
						return titleOts.key === item.ui
					})
					item.availability = mapOtsAvailability(otsDataForTitle);
				});
				this.setState({ dataToSet: titles });
			})
			.catch(err =>{
				this.setState({ dataToSet: titles });
			});
		}
	}

	sortData(data){
		return data.ListEntryContent.sort((prev, next) =>  next.IsHeldLocally - prev.IsHeldLocally);
	}

	
  
	booksCallFunctionCallBack(documentUi){	
		const { currentUi, dataToSet } = this.state;
		if (currentUi === documentUi) {
			return dataToSet;
		}
		getBookLists(documentUi, this.postAction);
		this.setState({ currentUi: documentUi });
		return this.state.dataToSet;
	}


	render() {
		if(this.state.bookLists.length){
			return (
				<AnalyticsWrapperContainer
					Component={<BookListsCarousel bookLists={this.state.bookLists} booksCallFunction={this.booksCallFunctionCallBack} availabilityConfiguration={this.availabilityConfiguration}/>}
					componentName={'Book List'}
					featureType={'Lists from NoveList'}
				/>
			);
		}
		else{
			return null;
		}
	}
}

export default BookListsCarouselContainer;



// WEBPACK FOOTER //
// ./src/react/containers/BookListsCarouselContainer.jsx